// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/engine-ignition.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/engine-ignition/engine-ignition.js';

mount([g0]);
